<template>
	<div class="points width">
		<aside>
			<div class="directory">
				<p><span>关于本会</span></p>
				<ul>
					<li @click="onSelect(1)">
						<span>本会简介</span>
						<i class="el-icon-arrow-right"></i>
					</li>
					<li @click="onSelect(2)">
						<span>本会章程</span>
						<i class="el-icon-arrow-right"></i>
					</li>
					<li @click="onSelect(3)">
						<span>组织架构</span>
						<i class="el-icon-arrow-right"></i>
					</li>
					<li @click="onSelect(4)">
						<span>联系方式</span>
						<i class="el-icon-arrow-right"></i>
					</li>
				</ul>
			</div>
		</aside>

		<div class="content">
			<!-- 本会简介 -->
			<div v-if="idx === 1">
				<p>
					<i class="el-icon-s-home"></i>
					<span @click="$router.replace('/')">网站首页</span>/<span> 关于本会/ 本会简介</span>
				</p>
				<h2 style="text-align:center;margin: 30px 0">省版权保护联合会简介</h2>
				<p style="text-indent:2em">广东省版权保护联合会（下称“版权联合会”）是经广东省民政厅正式批准成立并接受广东省版权局业务指导、具有公信力和社会影响力的省级社团组织。本会成立于1999年，现有会员单位近400多家，包括腾讯、网易、多益、三七互娱、酷狗、珠江电影、南方传媒、羊城晚报、深圳报业、深圳出版集团、南方文交所、横琴国际知交所、格力电器、平安科技、奥飞娱乐、金山软件、中望软件等知名企业，其中腾讯是版权联合会的会长单位。会员由我省版权产业与版权保护界以及与版权事业有关的机构和企事业单位自愿组成。</p>
				<br>
				<p style="text-indent:2em">版权联合会主要职责和任务是：收集盗版信息，联络、协调有关部门开展反盗版工作，保护会员权益；协助会员对盗版活动进行调查取证；协助会员向版权行政管理部门投诉或向司法机关起诉；开展版权保护研究、交流活动；开展版权法律知识的宣传、人员培训和信息交流；提供版权法律事务咨询；提供常年法律服务；开展版权代理以及与作品使用有关的认证、登记等其他版权服务。</p>
				<br>	
				<p style="text-indent:2em">版权联合会下设的各工委会和办事机构均为版权联合会的内设机构，在版权联合会的领导下独立开展工作和各项业务。</p>
				<br>
				<p style="text-indent:2em">广东省版权事务所是版权联合会的下设经营实体机构，成立于1993年，自1999年广东省版权事务所移交广东省版权保护联合会管理以后，具体负责承办作品自愿登记代理业务及其他版权服务。</p>
			</div>
			<!-- 本会章程 -->
			<div v-else-if="idx === 2">
				<p>
					<i class="el-icon-s-home"></i>
					<span @click="$router.replace('/')">网站首页</span>/<span> 关于本会/ 本会章程</span>
				</p>
				<img width="100%" src="../../assets/zc/imgnew-1.jpg" alt="">
				<img width="100%" src="../../assets/zc/imgnew-2.jpg" alt="">
				<img width="100%" src="../../assets/zc/imgnew-3.jpg" alt="">
				<img width="100%" src="../../assets/zc/imgnew-4.jpg" alt="">
				<img width="100%" src="../../assets/zc/imgnew-5.jpg" alt="">
				<img width="100%" src="../../assets/zc/imgnew-6.jpg" alt="">
				<img width="100%" src="../../assets/zc/imgnew-7.jpg" alt="">
				<img width="100%" src="../../assets/zc/imgnew-8.jpg" alt="">
				<img width="100%" src="../../assets/zc/imgnew-9.jpg" alt="">
				<img width="100%" src="../../assets/zc/imgnew-10.jpg" alt="">
			</div>
			<!-- 组织机构 -->
			<div v-else-if="idx === 3">
				<p>
					<i class="el-icon-s-home"></i>
					<span @click="$router.replace('/')">网站首页</span>/<span> 关于本会/ 组织机构</span>
				</p>
				<pre>
					<h2 style="text-align:center"> 组织机构</h2>
				</pre>
			</div>
			<div v-else>
				<p>
					<i class="el-icon-s-home"></i>
					<span @click="$router.replace('/')">网站首页</span>/<span> 关于本会/ 联系方式</span>
				</p>
				<div style="margin:0 20px;color:gray;line-height:30px">
					<h2 style="text-align:center;color:gray;margin:20px 0"> 联系方式</h2>
					<br>
					<div>联系人：胡小姐、曾小姐</div>
					<div>电话：020-37667333、37638239</div>
					<div>传真：020-37638192</div>
					<div>地址：广州市海珠区新港东路1066号国茶荟3-B01</div>
					<div>网址：www. gdcopyright.org.cn</div>
					<div>微信公众号二维码：</div>
					<img width="200px" src="../../assets/1595300177.jpg" alt="">
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				value: '',
				idx: 1,
			};
		},
		watch: {
            "$route": {
                handler(route) {
                    console.log(route)
                    if(route.name == 'points') {
                        this.onSelect(route.query.idx)
                    }
                }
            }
        },
		mounted() {
			this.onSelect(this.$route.query.idx)
		},
		methods: {
			onSelect(val) {
				this.idx = val
				console.log(val)
			},
		},
	};
</script>
<style>
	.el-divider--horizontal {
		margin: 10px 0;
	}
</style>
<style scoped>
	.points {
		margin: 20px auto;
		margin-bottom: 100px;
		display: flex;
	}

	aside {
		width: 15%;
	}

	.directory p,
	.contact p {
		border-bottom: 1px solid #ddd;
		box-sizing: border-box;
		margin-top: 20px;
	}

	.directory p span,
	.contact p span {
		display: inline-block;
		padding: 7px 10px;
		font-weight: bold;
		border-bottom: 2px solid #016fb8;
	}

	.directory ul {
		margin-top: 10px;
	}

	.directory ul li span {
		width: 140px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.directory ul li span:hover {
		color: #016fb8;
		font-weight: bold;
		cursor: pointer;
	}

	.directory ul li {
		background: #ddd;
		margin-top: 4px;
		padding: 10px;
		color: gray;
		font-size: 14px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.content {
		width: 80%;
		margin-top: 27px;
		margin-left: 30px;
		font-family: '宋体';
		color: gray;
		line-height: 30px;
	}

	.content div p:first-child {
		width: 100%;
		border-bottom: 1px solid #ddd;
		padding-bottom: 10px;
		color: gray;
	}

	.content div p:first-child i {
		margin-right: 10px;
	}

	.content div p:first-child span:hover {
		color: #016fb8;
		cursor: pointer;
	}
</style>
